import { render, staticRenderFns } from "./SplitInformation.vue?vue&type=template&id=7447841f&scoped=true&"
import script from "./SplitInformation.vue?vue&type=script&lang=ts&"
export * from "./SplitInformation.vue?vue&type=script&lang=ts&"
import style0 from "./SplitInformation.vue?vue&type=style&index=0&id=7447841f&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7447841f",
  null
  
)

export default component.exports